import "./creationwizard.scss";
import * as React from "react";
import { type IconProp } from "@fortawesome/fontawesome-svg-core";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";

interface Props {
    currentPage: number;
    totalPages: number;
    onClick: (pageIndex: number) => void;
}

export default class CreationWizardProgress extends React.Component<Props> {
    public render(): React.ReactNode {
        const content = [];

        for(let i = 0; i < this.props.totalPages; i++) {
            let classes = "creation-wizard-progress-stage";
            let icon: IconProp = "circle";

            if(i === this.props.currentPage - 1) {
                classes += " creation-wizard-progress-current";
                icon = "dot-circle";
            }

            content.push(
                <div
                    className={classes}
                    key={i}
                    onClick={(): void => this.props.onClick(i)}
                >
                    <FontAwesomeLight icon={icon} />
                </div>
            );
        }

        return (
            <div className="creation-wizard-progress">
                {content}
            </div>
        );
    }
}
